import { render, staticRenderFns } from "./TransferenciaOrdenCompra.vue?vue&type=template&id=0f455b62&scoped=true&"
import script from "./TransferenciaOrdenCompra.vue?vue&type=script&lang=js&"
export * from "./TransferenciaOrdenCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f455b62",
  null
  
)

export default component.exports